import NotificaionOrderInterval from "../symbols/notificationOrderInterval";

export interface IState {
  interval: number;
}
const initialState: IState = {
  interval: 0,
};

function NotificationOrderInterval(state = initialState, action: any) {
  switch (action.type) {
    case NotificaionOrderInterval.SET_NOTIFICATION_ORDER_INTERVAL:
      return { ...state, interval: action.payload };
    case NotificaionOrderInterval.CLEAR_NOTIFICATION_ORDER_INTERVAL:
      return { ...state, interval: 0 };
    default:
      return state;
  }
}
export default NotificationOrderInterval;
